import React, { useCallback } from 'react';
import { getFormikError, withFormikField } from 'utils/formik';
import { Spacer, Checkbox, Field } from '@ontruck/orc';

import {
  StyledFirstColumn,
  StyledExtraContainer,
  StyledFieldWrapper,
  ReturnExtraStyles,
} from './styled';

import { RETURN_EXTRA, MODIFIED_PRICE_EXTRA } from 'modules/shipper-order/Form/constants';

export const t = {
  label: 'Return due to incident',
  base: 'Base price',
  returned: 'Returned SO',
  currencies: {
    EUR: '€',
    GBP: '£',
  },
};

export function getNumberFromString(input) {
  if (!input) return '';
  if (typeof input === 'number') return input;

  const inputNumbers = input.replace(/[^\d]/g, '');
  return inputNumbers ? Number(inputNumbers) : '';
}

const ReturnExtra = ({ currency, form, className, isLast, disabled }) => {
  const { values: formValues, setFieldValue } = form;

  const formExtras = formValues?.extra_prices;
  const formExtra = formExtras?.find((extra) => extra.concept === RETURN_EXTRA);
  const hasModifedExtra = !!formExtras?.find((extra) => extra.concept === MODIFIED_PRICE_EXTRA);

  const formExtrasNames = (formExtras || []).map((extra) => extra?.concept);
  const formExtraPosition = formExtrasNames.indexOf(RETURN_EXTRA);
  const error = Object.keys(
    getFormikError({ field: { name: `extra_prices.${formExtraPosition}` }, form }) || {}
  ).length;

  const isChecked = !!formExtra;

  const toggleExtra = (e, { value: activatingExtra }) => {
    if (disabled || hasModifedExtra) return;
    if (activatingExtra) return createReturnExtra();

    return setFieldValue(
      'extra_prices',
      formExtras.filter((extra) => extra.concept !== RETURN_EXTRA)
    );
  };

  const changeReferralOrder = (_, { value }) => {
    setFieldValue('return_for', getNumberFromString(value));
  };

  const changeReturnPriceAmount = useCallback(
    (_, { value }) => {
      const formExtrasWithoutReturnExtra = (formExtras || []).filter(
        (extra) => extra.concept !== RETURN_EXTRA
      );

      setFieldValue('extra_prices', [
        ...(formExtrasWithoutReturnExtra || []),
        { ...(formExtra || {}), amount: value },
      ]);
    },
    [formExtra, formExtras, setFieldValue]
  );

  const createReturnExtra = () => {
    setFieldValue('extra_prices', [
      ...(formExtras || []),
      {
        concept: RETURN_EXTRA,
        amount: '',
        include_in_base: false,
        reviewed_by_shipper: false,
        type: 'NUMERIC',
        referral_shipper_order_id: null,
      },
    ]);
  };

  const formatAmount = useCallback(() => {
    if (!formExtra.amount) return;

    changeReturnPriceAmount(null, { value: parseFloat(formExtra.amount).toFixed(2) });
  }, [formExtra, changeReturnPriceAmount]);

  return (
    <div className={className}>
      <StyledExtraContainer isLast={isLast}>
        <div className="container">
          <StyledFirstColumn p="S">
            <Spacer>
              <Checkbox
                checked={isChecked}
                label={t.label}
                onChange={toggleExtra}
                dataE2E="return_checkbox"
                disabled={disabled || hasModifedExtra}
              />
            </Spacer>
          </StyledFirstColumn>

          <div className="inner-container">
            <StyledFieldWrapper visible={isChecked} fullWidth>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <div className="inner-field-container">
                  <Field
                    fullWidth
                    value={formValues?.return_for || ''}
                    label={t.returned}
                    width="XS"
                    onChange={changeReferralOrder}
                    invalid={!formValues?.return_for}
                  />
                </div>
                <div className="inner-field-container">
                  <Field
                    name="amount-field"
                    fullWidth
                    value={formExtra?.amount || ''}
                    label={t.base}
                    width="XS"
                    asideRightText={t.currencies[currency]}
                    onChange={changeReturnPriceAmount}
                    invalid={!!error}
                    onBlur={formatAmount}
                  />
                </div>
              </div>
            </StyledFieldWrapper>
          </div>
        </div>
      </StyledExtraContainer>
    </div>
  );
};

export default withFormikField(ReturnExtraStyles(ReturnExtra));
